module.exports = __webpack_public_path__ + "img/T6-A-xh_07.9590d2eb.png";